import React, { useState } from "react";
import { useField, Formiz, useForm, FormizStep } from "@formiz/core";
import { isEmail, isRequired } from "@formiz/validations";
import { Select } from "antd";
import FormInput from "./FormInput";
// import { Rating } from "react-simple-star-rating";
import Rating from "../Rating";
function FeedBackContent() {
  const myForm = useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [selectValue1, setSelectValue1] = useState();
  const [selectValue2, setSelectValue2] = useState();
  const [selectValue3, setSelectValue3] = useState();
  const [rating, setRating] = useState();
  const { Option } = Select;

  const handleRating=(i)=>{
    setRating(i);
  }
  const ratingNumber=rating+1

  const onChangeSelect1 = (values) => {
    setSelectValue1(values);
  };
  const onChangeSelect2 = (values) => {
    setSelectValue2(values);
  };
  const onChangeSelect3 = (values) => {
    setSelectValue3(values);
  };
  const submitForm = (values) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      alert(
        JSON.stringify(values)+","+selectValue1+","+selectValue2+","+selectValue3+" "+ratingNumber
        
      );
      const step = myForm.getFieldStepName("email");
      myForm.goToStep(step);
    }, 1000);
  };

  return (
    <div className="feedBackContent">
      <div className="container">
        <div className="titlepage">
          <h5>
            Mandala ơi, hãy để Mandala mang tới bạn những trải nghiệm ngày một
            tốt hơn bằng việc hoàn thành khảo sát sau nhé!
          </h5>
        </div>

        <div className="feedBackBox">
          <Formiz onValidSubmit={submitForm} connect={myForm}>
            <form
              noValidate
              onSubmit={myForm.submitStep}
              className="formFeedNack"
            >
              <div className="formContent">
                <FormizStep name="step1">
                  <div className="mr">
                    <h5 className="title">
                      JO vui lòng cho biết thông tin cá nhân nhé
                    </h5>
                    <FormInput
                      name="name"
                      label="Họ và tên"
                      required="Vui lòng nhập họ tên"
                      placeholder="Nhập họ và tên của bạn"
                    />
                    <FormInput
                      name="email"
                      label="Email hoặc số điện thoại"
                      required="Vui lòng điền Email hoặc Số điện thoại "
                      placeholder="email@abc.com/0963748756"
                      validations={[
                        {
                          rule: isEmail(),
                          message: "Vui lòng điền đúng định dạng email",
                        },
                      ]}
                    />
                    <FormInput
                      name="other"
                      label="Thông tin khác"
                      placeholder="Số phòng, mã đặt phòng"
                    />
                  </div>
                  <div className="mr">
                    <h5 className="title">
                      Cảm ơn JO đã lựa chọn lưu trú tại SOJO. Hãy chia sẻ cảm
                      nhận của bạn với chúng tôi!
                    </h5>
                    <Select
                      defaultValue="Vị trí thuận tiện"
                      name="select1"
                      onChange={(values)=>onChangeSelect1(values)}
                    >
                      <Option value="Vị trí thuận tiện">
                        Vị trí thuận tiện
                      </Option>
                      <Option value="Giá tốt">Giá tốt</Option>
                      <Option value="Trang thiết bị thuận ích">
                        Trang thiết bị thuận ích
                      </Option>
                      <Option value="Trải nghiệm công nghệ">
                        Trải nghiệm công nghệ
                      </Option>
                      <Option value="Được bạn bè giới thiệu">
                        Được bạn bè giới thiệu
                      </Option>
                      <Option value="Khác">Khác</Option>
                    </Select>
                  </div>
                  <div className="mr">
                    <h5 className="title">
                      JO ơi, bạn đã đặt phòng qua kênh nào?
                    </h5>
                    <Select
                      defaultValue="Website Mandala"
                      name="select2"
                      onChange={(values)=>onChangeSelect2(values)}
                    >
                      <Option value="Website Mandala">Website Mandala</Option>
                      <Option value="Công ty đặt cho">Công ty đặt cho</Option>
                      <Option value="Khác">Khác</Option>
                    </Select>
                  </div>
                  <div className="mr">
                    <h5 className="title">
                      Bạn có gặp vấn đề gì trong suốt chặng lưu trú ?
                    </h5>
                    <Select
                      defaultValue="Phòng"
                      name="select3"
                      onChange={(values)=>onChangeSelect3(values)}
                    >
                      <Option value="Phòng">Phòng</Option>
                      <Option value="Ẩm thực và đồ uống">
                        Ẩm thực và đồ uống
                      </Option>
                      <Option value="An ninh, bảo vệ">An ninh, bảo vệ</Option>
                      <option value="Không có vấn đề">Không có vấn đề</option>
                    </Select>
                  </div>
                  <div className="mr">
                    <h5 className="title">Cho Mandala biết chi tiết</h5>
                    <FormInput name="otherDetail" />
                  </div>
                </FormizStep>
                <FormizStep name="step2">
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Bạn sẽ giới thiệu thương hiệu khách sạn SOJO cho bạn bè
                        ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          "Bạn sẽ giới thiệu thương hiệu khách sạn SOJO cho bạn bè ?"
                        }
                        handleRating={handleRating}
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Nhận phòng tức tốc có hợp ý Mandala ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={"Nhận phòng tức tốc có hợp ý Mandala ?"}
                        handleRating={handleRating}
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Trải nghiệm trong phòng có khiến Mandala thoải mái ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          " Trải nghiệm trong phòng có khiến Mandala thoải mái ?"
                        }
                        handleRating={handleRating}
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Trải nghiệm Mandala 247 có ấn tượng với bạn ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating="Trải nghiệm Mandala 247 có ấn tượng với bạn ?"
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Trả phòng nhanh chóng có khiến bạn hài lòng ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          "Trả phòng nhanh chóng có khiến bạn hài lòng ?"
                        }
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Mức độ đáng giá về kì lưu trú lần này của bạn ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          "Mức độ đáng giá về kì lưu trú lần này của bạn ?"
                        }
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Mức độ mong muốn đánh giá về các dịch vụ của chúng tôi ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          "Mức độ mong muốn đánh giá về các dịch vụ của chúng tôi ?"
                        }
                      />
                    </div>
                  </div>
                  <div className="row starFeedback">
                    <div className="col-lg-6 col-12">
                      <h5 className="title">
                        Mức độ mong muốn nhận được các ưu đãi hấp dẫn từ chúng
                        tôi ?
                      </h5>
                    </div>
                    <div className="col-lg-6 col-12">
                      <Rating
                        totalStars={5}
                        questionRating={
                          "Mức độ mong muốn nhận được các ưu đãi hấp dẫn từ chúng tôi ?"
                        }
                      />
                    </div>
                  </div>
                </FormizStep>
              </div>
              <div className="formFooter">
                <div>
                  {!myForm.isFirstStep && (
                    <button
                      className="styleBtn btnPrev"
                      type="button"
                      onClick={myForm.prevStep}
                    >
                      Bỏ qua
                    </button>
                  )}
                </div>
                <div>
                  {myForm.isLastStep ? (
                    <button
                      className="styleBtn submit"
                      type="submit"
                      disabled={
                        isLoading || (!myForm.isValid && myForm.isStepSubmitted)
                      }
                    >
                      {isLoading ? "Loading..." : "Gửi đánh giá"}
                    </button>
                  ) : (
                    <button
                      className="styleBtn  btnNext"
                      type="submit"
                      disabled={!myForm.isStepValid && myForm.isStepSubmitted}
                    >
                      Tiếp tục
                    </button>
                  )}
                </div>
              </div>
            </form>
          </Formiz>
        </div>
        <div className="feedBackMore">
          <div className="imgStyle">
            <img className="img-fluid" src="/images/tripadvisor.png" alt="" />
          </div>
          <p>Mandala có thể đánh giá thông qua TripAdvisor</p>
          <button className="btnStyle">Đánh giá</button>
        </div>
      </div>
    </div>
  );
}
export default FeedBackContent;
